





















































































































































































































































// @ts-nocheck
import Vue from "vue";
import { Ref } from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import AppTableRow from "@/components/table/AppTableRow.vue";
import LevelLabel from "@/components/LevelLabel.vue";
import { AppAnalytics } from "@/analytics";
import { debounce } from "@/fp";
import { AI_AGENT_LABEL, genai_app_name, is_genai_app } from "@/common/ai-agent";

interface RowCommonData {
  markingEvents?: Ref<Record<string, boolean>>;
}

export const EVENT_ROW_SHOW_DETAILS = "event-table-row/show-details";
export const EVENT_ROW_CLUSTER = "event-table-row/cluster";
export const EVENT_ROW_TOGGLE_MARK = "event-table-row/toggle-mark";

export type EventRowPopupType = "items" | "people";

export interface EventRowPopupProps {
  type: EventRowPopupType;
  id: string;
  items?: any[];
  people?: any[];
  position: { left: number; bottom: number };
}

export default Vue.extend({
  components: {
    AppTableRow,
    LevelLabel,
  },
  props: ["source"],
  setup(props) {
    const getPosition = (ev: MouseEvent) => {
      const parent = (ev.srcElement as Element).parentElement as Element;
      const { left, bottom } = parent.getBoundingClientRect();
      return { left, bottom };
    };
    const showFiles = (event: MouseEvent) => {
      // @ts-ignore
      const { items, exposedTo } = props.source;
      EventBus.emit(EVENT_ROW_SHOW_DETAILS, {
        // @ts-ignore
        id: props.source.id,
        type: "items",
        items: items,
        people: exposedTo,
        position: getPosition(event),
      } as EventRowPopupProps);
      AppAnalytics.report({
        component: "Investigation",
        //@ts-ignore
        eventName: `Investigation_tier#2 events tab_click on files ${props.source.items.count}`,
      });
    };
    const showPeople = (event: MouseEvent) => {
      // @ts-ignore
      const { items, exposedTo } = props.source;
      EventBus.emit(EVENT_ROW_SHOW_DETAILS, {
        // @ts-ignore
        id: props.source.id,
        type: "people",
        people: exposedTo,
        items: items,
        position: getPosition(event),
      } as EventRowPopupProps);
      AppAnalytics.report({
        component: "Investigation",
        //@ts-ignore
        eventName: `Investigation_tier#2 events tab_click on exposed to ${props.source.exposedTo.count}`,
      });
    };

    const goToCluster = () => {
      // @ts-ignores
      if (props.source.items) {
        EventBus.emit("event-card_cluster", {
          // @ts-ignores
          item: props.source.items.item,
          // @ts-ignores
          eventId: props.source.id,
        });
      }
    };

    const showMenu = (event: MouseEvent) => {
      EventBus.emit("showEventMenu", { item: props.source, event });
    };

    const showDetailsPopup = (section: string) => {
      EventBus.emit("show_event_details", { item: props.source, section });
    };

    const toggle_handled = (source: any) => {
      EventBus.emit(EVENT_ROW_TOGGLE_MARK, {
        event_id: source.id,
        mark: !source.mark,
      });
    };

    const is_marking = (event_id: string) => {
      const data = props.common_row_data as RowCommonData | undefined;
      const map = data?.markingEvents;
      if (!map) {
        return false;
      }
      return !!map.value?.[event_id];
    };

    const show_justification = debounce(200)(
      async (event_id: string, justification_id: string) => {
        EventBus.emit("show_justification", {
          justification_id: justification_id === "NONE" ? "" : justification_id,
          event_id,
        });
      }
    );
    return {
      AI_AGENT_LABEL,
      genai_app_name,
      is_genai_app,
      showMenu,
      showFiles,
      showPeople,
      goToCluster,
      showDetailsPopup,
      show_justification,
      toggle_handled,
      is_marking,
    } as any;
  },
});
